import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactSwitch from 'react-switch';
import Icon from '../../../../../../ui/Icon';
import { TCITooltip } from '../../../../../../ui/Tooltip';
import Tooltip from '../../../../../../common/Tooltip';
import useFlags from '../../../../../../../hooks/useFlags';
import styles from './Switch.module.scss';

const Switch = ({ checked, id, label, onChange, tooltip }) => {
  const appendEl = useRef();
  const { teacherPacedMode } = useFlags();

  if (teacherPacedMode) {
    return (
      <div ref={appendEl} className={styles.switch}>
        <label className={styles.label} htmlFor={id}>
          {label}
          {tooltip && (
            <TCITooltip>
              <TCITooltip.Trigger asChild>
                <button
                  aria-label={`Tooltip: ${tooltip}`}
                  className={styles.tooltipIcon}
                  type="button"
                  onMouseDown={e => e.preventDefault()}
                >
                  <Icon color="#777770" icon="InfoAlternate" />
                </button>
              </TCITooltip.Trigger>
              <TCITooltip.Content>{tooltip}</TCITooltip.Content>
            </TCITooltip>
          )}
        </label>
        <ReactSwitch
          aria-label={label}
          checked={checked}
          checkedIcon={false}
          handleDiameter={20}
          height={24}
          id={id}
          offColor="#cccccc"
          uncheckedIcon={false}
          width={48}
          onChange={onChange}
          onColor="#522e91"
        />
      </div>
    );
  }

  return (
    <div ref={appendEl} className={styles.label}>
      <label htmlFor={id}>
        {label}
        {tooltip && (
          <Tooltip appendTo={appendEl && appendEl.current} content={tooltip} interactive={false}>
            <i aria-label={`Tooltip: ${tooltip}`} className={`${styles.tooltipIcon} fa fa-info-circle`} />
          </Tooltip>
        )}
      </label>
      <ReactSwitch
        aria-label={label}
        checked={checked}
        checkedIcon={false}
        handleDiameter={20}
        height={24}
        id={id}
        offColor="#cccccc"
        uncheckedIcon={false}
        width={48}
        onChange={onChange}
        onColor="#522e91"
      />
    </div>
  );
};

Switch.defaultProps = {
  label: '',
  tooltip: null,
};

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
};

export default Switch;
